import React, { useEffect } from "react";
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";
// import Login from "../screens/front/Login/Login.tsx";
import ProtectedRoute from "./ProtectedRoutes";
import Unauthorized from "./UnAuthorized";
// import AdminDashboard from "../screens/admin/AdminDashboard/AdminDashboard.tsx";
// import ManageAdmin from "../screens/admin/ManageAdmin/ManageAdmin.tsx"; // Import ManageAdmin component
// import Home from "../screens/front/Home/Home.tsx";
import Layout from "../Components/Layout/Layout";
import Home from "../Screens/Home";
import Login from "../Screens/Login/Login";
import Dashboard from "../Screens/Dashboard/Dashboard";
import Reports from "../Screens/Reports/reports";
import ScoreCard from "../Screens/ScoreCard/ScoreCard";
import FixIt from "../Screens/FixIt/FixIt";
import ForgotPassword from "../Screens/Login/ForgotPassword";
import { Box } from "@mui/material";
import LeftSide from "../Screens/Login/LeftSide";
import Otp from "../Screens/Login/Otp";
import SetPassword from "../Screens/Login/SetPassword";
import StarRating from "../Screens/StarRating/StarRating";
import PrivateRoute from "./PrivateRoutes";
import { Provider, useDispatch } from "react-redux";
import store from "../global/config/store";
import TrendData from "../Screens/TrendData/TrendData";
import GroupMonthlySiteScore from "../Screens/Reports/GroupMonthlySiteScore";
import CategoryReport from "../Screens/Reports/CategoryReport";
import CustomeMonthlyReport from "../Screens/Reports/CustomeMonthlyReport";
import MonthlyPdf from "../Screens/Reports/MonthlyPdf";
import QuestionSummaryReport from "../Screens/Reports/QuestionSummaryReport";
import ReportCenter from "../Screens/Reports/ReportCenter";
import SiteSummary from "../Screens/Reports/SiteSummary";
import ReportStarRating from "../Screens/Reports/ReportStarRating";
import Bsc from "../Screens/Bsc/Bsc";
import { ApiGetClientEntityId, ApiRegionVenues, ApiUsersLogin } from "../apiService/Core/Apicall";
import { setRegion } from "../global/config/Reducer/RegionSlice";
import { log } from "console";
import { toast } from "react-toastify";
import CheckScoreCard from "../Screens/CheckScoreCards/CheckScoreCard";
import Checklist_A from "../Screens/Checklist/Checklist_A";
import CHecklist_V from "../Screens/Checklist/CHecklist_V";
import ManageVenue from "../Screens/Manage Venues/ManageVenue";
import ManageArea from "../Screens/Manage Areas/ManageArea";
import FeedbackQuestions from "../Screens/FeedbackQuestions/FeedbackQuestions";
import DownloadScorecard from "../Screens/ScoreCard/DownloadScorecard";
import VenueDashboard from "../Screens/Dashboard/VenueDashboard";
import CategoryComparisionReport from "../Screens/StarRating/CategoryComparisionReport";
import { setallclientEntityIds } from "../global/config/Reducer/WholeGroupSlice";
import InsightBot from "../Screens/InsightBot/InsightBot";
import ComparisionReport from "../Screens/Comparision Report/ComparisionReport";
import storage from "../utils/storage";
import DataExplorer from "../Screens/DataExplorer/DataExplorer";
import ChecklistList from "../Screens/New Checklist_A/ChecklistList";
import CreateBusinessChecklistQuestions from "../Screens/New Checklist_A/Manage Checklist Questions/CreateChecklistQuestions";
import ChangeChecklistQuestionOrder from "../Screens/New Checklist_A/Manage Checklist Questions/ChangeChecklistQuestionOrder";
import CreateNewChecklistQuestion from "../Screens/New Checklist_A/CreateQuestion/CreateQuestion";
import VenueChecklistList from "../Screens/New Checklist_V/VenueChecklistList";
import VenueCheklistForm from "../Screens/New Checklist_V/VenueCheklistForm";
import ClientChecklistDashboard from "../Screens/New Checklist_A/ClientChecklistDashboard";
import VenueChecklistDashboard from "../Screens/New Checklist_V/VenueChecklistDashboard";
import SubmittedChecklistList from "../Screens/New Checklist_A/SubmittedChecklistList";
import CreateChecklist from "../Screens/New Checklist_A/CreateChecklist";
import OtpVerification from "../Screens/2FA/OtpVerification";
// import EditAccessGroup from "../screens/admin/ManageAdmin/EditAccessGroup.tsx";
// import AddOrUpdate from "../screens/admin/ManageAdmin/AddOrUpdateAdmin.tsx";
// import ManageStore from "../screens/admin/ManageStore/ManageStore.tsx";
// import AddOrUpdateStore from "../screens/admin/ManageStore/AddOrUpdateStore.tsx";
// import ManageClients from "../screens/admin/ManageClients/ManageClients.tsx";
// import AddOrUpdateClients from "../screens/admin/ManageClients/AddOrUpdateClients.tsx";
// import ManageVenue from "../screens/admin/ManageVenue/ManageVenue.tsx";
// import AddOrUpdateVenue from "../screens/admin/ManageVenue/AddOrUpdateVenue.tsx";
// import ImportExportQuestions from "../screens/admin/ImportExportQuestions/ImportExportQuestions.tsx";
// import ImportExportQuestionsManager from "../screens/admin/ImportExportQuestionsManager/ImporttExportQuestionsManager.tsx";
// import AreaManager from "../screens/admin/AreaManager/AreaManager.tsx";
// import AddOrUpdateAreaManager from "../screens/admin/AreaManager/AddOrUpdateAreaManager.tsx";
// import VenueMap from "../screens/admin/ManageVenue/VenueMap.tsx";
// import BriefJson from "../screens/admin/BriefJson/BriefJson.tsx";
// import AddOrUpdateBriefJson from "../screens/admin/BriefJson/AddOrUpdateBriefJson.tsx";
// import ViewEditorsBusiness from "../screens/admin/ManageStore/ViewEditorsBusiness.tsx";
// import ViewEditorsVenue from "../screens/admin/ManageVenue/ViewEditorsVenue.tsx";
// import TermsAndConditions from "../components/TermsAndConditions/TermsAndConditions.tsx";
// import TrainingCalendar from "../screens/admin/TrainingCalendar/TrainingCalendar.tsx";
// import ManageVisitTime from "../screens/admin/ManageVisitTime/ManageVisitTime.tsx";
// import AddOrUpdateManageVisit from "../screens/admin/ManageVisitTime/AddOrUpdateManageVisit.tsx";
// import ViewJobCriteriaBusiness from "../screens/admin/ManageStore/ViewJobCriteriaBusiness.tsx";
// import ViewJobCriteriaVenue from "../screens/admin/ManageVenue/ViewJobCriteriaVenue.tsx";
// import CreateAllocations from "../screens/admin/CreateAllocations/CreateAllocations.tsx";
// import ApproveAllocation from "../screens/admin/ApproveAllocation/ApproveAllocation.tsx";
// import ShopperApplications from "../screens/admin/ShopperApplications/ShopperApplications.tsx";
// import ViewShopperApplication from "../screens/admin/ShopperApplications/ViewShopperApplication.tsx";
// import OrphanAllocation from "../screens/admin/OrphanAllocation/OrphanAllocation.tsx";
// import InviteShopper from "../screens/admin/OrphanAllocation/InviteShopper.tsx";
// import MonthlyCalendar from "../screens/admin/MonthlyCalendar/MonthlyCalendar.tsx";
// import CreateNewTemplate from "../screens/admin/CreateNewTemplate/CreateNewTemplate.tsx";
// import QuestionBank from "../screens/admin/QuestionBank/QuestionBank.tsx";
// import CreateNewQuestion from "../screens/admin/CreateNewQuestion/CreateNewQuestion.tsx";
// import TemplateListing from "../screens/admin/Template Listing/TemplateListing.tsx";
// import CreateClientTemplate from "../screens/admin/CreateClientTemplate/CreateClientTemplate.tsx";
// import CreateVenueSiteTemplate from "../screens/admin/CreateVenueSiteTemplate copy/CreateVenueSiteTemplate.tsx";
// import ManageReports from "../screens/admin/ManageReports/ManageReports.tsx";
// import AllReports from "../screens/admin/Manage Reports/AllReports.tsx";
// import CreateOrEditScoreCard from "../screens/admin/ScoreCardComponents/CreateOrEditScoreCard.tsx";
// import ShopperRequestDate from '../screens/admin/Shopper Req Date/ShopperRequestDate.tsx'
const AppRoutes: React.FC = () => {

  const params = new URLSearchParams(window.location.search);
  const value1 = params.get('adminuserid');
  const value2 = params.get('validation');
  const navigate = useNavigate()
  const dispatch = useDispatch()


  const Autologin = async () => {
    try {
      const data2 = {
        loginType: 'tokenLogin',
        adminId: value1,
        loginToken: value2,
        ipAddress: "127.0.0.1",
        browserName: "Chrome"
      }
      const response = await ApiUsersLogin(data2)
      storage.setItem('token', response.token)
      localStorage.setItem('token', response.token)
      if (response.userDetails.role.roleName === 'clientadmin' && window.location.hostname.includes('client') && response.otherDetails.ClientGroupName.clientGroupName != "ALDI" && response.otherDetails.ClientGroupName.clientGroupName != "BLOOMS") { storage.setItem('ClientGroupName', response.otherDetails.ClientGroupName.clientGroupName); localStorage.setItem('ClientGroupName', response.otherDetails.ClientGroupName.clientGroupName) }
      if (response.userDetails.role.roleName !== 'clientadmin' && window.location.hostname.includes('client') && response.otherDetails.clientGroupName != "ALDI" && response.otherDetails.clientGroupName != "BLOOMS") { storage.setItem('ClientGroupName', response.otherDetails.clientGroupName); localStorage.setItem('ClientGroupName', response.otherDetails.clientGroupName) }
      const clientgroupname = storage.getItem('ClientGroupName')
      // if (storage.getItem("token") && response.userDetails.role.roleName === 'clientadmin' ? (clientgroupname === "MM" && (response.otherDetails.ClientGroupName.clientGroupName === "TRANSPORT")) : (clientgroupname === "MM" && (response?.otherDetails?.clientGroupName === "TRANSPORT"))) {
      //   storage.setItem('userRole', response.userDetails.role.roleName)
      //   response.userDetails.role.roleName === 'clientadmin' && storage.setItem('clientId', response.otherDetails.ClientID)
      //   storage.setItem('userData', JSON.stringify(response.userDetails));
      //   const response2 = response.userDetails.role.roleName === 'clientadmin' && await ApiGetClientEntityId(response.otherDetails.ClientID)
      //   storage.setItem('clientEntityId', response.userDetails.role.roleName === 'clientadmin' ? response2.data[0][0].clientEntityId : response.otherDetails.clientEntityId)
      //   response.userDetails.role.roleName === 'clientadmin' && storage.setItem('clientEntityName', response2.data[0][0].entityName)
      //   storage.setItem('ActiveTask', "Dashboard")
      //   navigate("/maindashboard/dashboard");
      // }
      if ((storage.getItem("token") && response.userDetails.role.roleName === 'clientadmin') ? (response.otherDetails.ClientGroupName.clientGroupName === clientgroupname) : (response?.otherDetails?.clientGroupName === clientgroupname)) {
        storage.setItem('userRole', response.userDetails.role.roleName)
        localStorage.setItem('userRole', response.userDetails.role.roleName)
        response.userDetails.role.roleName === 'clientadmin' && storage.setItem('clientId', response.otherDetails.ClientID)
        response.userDetails.role.roleName === 'clientadmin' && localStorage.setItem('clientId', response.otherDetails.ClientID)
        storage.setItem('userData', JSON.stringify(response.userDetails));
        localStorage.setItem('userData', JSON.stringify(response.userDetails));
        localStorage.setItem('userOtherData', JSON.stringify(response.otherDetails));
        storage.setItem('userOtherData', JSON.stringify(response.otherDetails));
        storage.setItem('INF', response?.otherDetails?.hideFixIt);
        storage.setItem('ISC', response?.otherDetails?.hideSiteComparison);
        response?.otherDetails?.areas?.[0]?.areaId && storage.setItem('areaId', response?.otherDetails?.areas?.[0]?.areaId)
        response?.otherDetails?.areas?.[0]?.areaName && storage.setItem('areaName', response?.otherDetails?.areas?.[0]?.areaName)
        const response2 = response.userDetails.role.roleName === 'clientadmin' && await ApiGetClientEntityId(response.otherDetails.ClientID)
        response.userDetails.role.roleName !== 'clientadmin' && storage.setItem('cssNPS', response?.otherDetails?.canClientSeeNPSScore)
        // response?.otherDetail?.venues?.[0]?.venueName && storage.setItem('cssNPS', response?.otherDetail?.venues?.[0]?.canClientSeeNPSScore)
        response2 && storage.setItem("ratingJson", response2.data[0][0].ratingJson)
        const allClientEntityIds = response2?.data?.[0]
          ?.sort((a: any, b: any) => a?.entityCode === "SON" ? Number(a.clientEntityId) - Number(b.clientEntityId) : Number(b.clientEntityId) - Number(a.clientEntityId))
          ?.map((item: any) => item.clientEntityId)
          ?.join(",") || "";
        dispatch(setallclientEntityIds(allClientEntityIds))
        storage.getItem('userRole') === 'clientadmin' && storage.setItem('dwc', response2.data[0][0]?.isAllowDownloadWithoutComments);
        storage.getItem('userRole') === 'clientadmin' && storage.setItem('INF', response2.data[0][0]?.hideFixIt);
        storage.getItem('userRole') === 'clientadmin' && storage.setItem('ISC', response2.data[0][0]?.hideSiteComparison);
        storage.getItem('userRole') === 'clientadmin' && storage.setItem('cssNPS', response2.data[0][0]?.canClientSeeNPSScore);
        storage.setItem('clientEntityId', response.userDetails.role.roleName === 'clientadmin' ? response2.data[0][0].clientEntityId : response.otherDetails.clientEntityId)
        response.userDetails.role.roleName === 'clientadmin' && storage.setItem('clientEntityName', response2.data[0][0].entityName)
        storage.setItem('ActiveTask', "Dashboard")
        navigate("/maindashboard/dashboard");
      }
      else {
        alert("Invalid Acess")
      }

      // toast.success(response.message)
      if (storage.getItem("clientEntityId") && response.userDetails.role.roleName === 'clientadmin' ? (response.otherDetails.ClientGroupName.clientGroupName === clientgroupname) : (response?.otherDetails?.clientGroupName === clientgroupname)) {
        const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
        if (clientgroupname === 'ALDI') {
          const response3 = await ApiRegionVenues(data)
          dispatch(setRegion(response3.data))
        }
      }


    }
    catch (error: any) {
      alert(error)
      console.log(error)
    }
  }
  // useEffect(() => {
  //   if (value1 || value2) {
  //     const clientGroupName = (window.location.hostname.includes('aldi')) ? "ALDI" : window.location.hostname.includes('blooms') ? "BLOOMS" : "MM"
  //     storage.setItem('ClientGroupName', clientGroupName)
  //     if (value2) {
  //      console.log('Local storage clearing')
  //      storage.clear();
  //      console.log('Local storage cleared')
  //      setTimeout(() => {
  //        Autologin()
  //      }, 1000);
  //     }

  //   }
  // }, [params])
  useEffect(() => {
    if (value1 || value2) {
      const clientGroupName =
        window.location.hostname.includes('aldi')
          ? "ALDI"
          : window.location.hostname.includes('blooms')
            ? "BLOOMS"
            : "MM";

      if (value2) {
        storage.clear();
        localStorage.clear()
        setTimeout(() => {
          storage.setItem('ClientGroupName', clientGroupName);
          localStorage.setItem('ClientGroupName', clientGroupName);
          Autologin();
        }, 1000);
      }
    }
  }, [params]);

  const location = useLocation()
  const AuthRoutes = [
    "/login",
    "/ForgotPassword",
    "/otp",
    "/setpassword",
    "/verify"
  ];
  const isAuth = AuthRoutes.some((route) => location.pathname.startsWith(route));
  // const isLogin = storage.getItem('token')
  return (

    <Box bgcolor='white' height='100vh' className='d-flex row p-0 m-0' width='100%' >
      {isAuth &&
        <Box className='col-md-9 d-none d-lg-block h-100 px-0'>
          <LeftSide></LeftSide>
        </Box>
      }

      <Box position={'relative'} overflow={'auto'} className={`${isAuth ? 'col-lg-3  mx-auto col-xs-12 p-3 justify-content-center round-circle h-100 d-flex flex-column align-items-center' : 'p-0'}`}
      >
        <Provider store={store}>
          <Routes>
            <Route path='/' element={params && <Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify" element={<OtpVerification />} />
            <Route path="/ForgotPassword" element={<ProtectedRoute requiredstep="forgotpassword"><ForgotPassword /></ProtectedRoute>} />
            <Route path="/otp" element={<ProtectedRoute requiredstep='otp'><Otp /></ProtectedRoute>} />
            <Route path="/setpassword" element={<ProtectedRoute requiredstep="setpassword"><SetPassword /></ProtectedRoute>} />
            <Route
              path="/maindashboard/dashboard"
              element={
                <PrivateRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route path="/maindashboard/reports/:reportType" element={<PrivateRoute>
              <Layout>
                <Reports />
              </Layout>
            </PrivateRoute>} />
            <Route
              path="/maindashboard/reports"
              element={
                storage.getItem('userRole') === 'venueadmin' ?
                  storage.getItem("ISC") == "1" ?
                    <Navigate to='/maindashboard/reports/custommonthlyreport' />
                    : <Navigate to='/maindashboard/reports/monthlypdf' />
                  : <Navigate to='/maindashboard/reports/groupmonthlysitescore' />
              }
            />

            <Route
              path="/maindashboard/scorecard"
              element={
                <PrivateRoute>
                  <Layout>
                    <ScoreCard />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/fixit"
              element={
                <PrivateRoute>
                  <Layout>
                    <FixIt />
                  </Layout>
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/maindashboard/checklist"
              element={
                <PrivateRoute>
                  <Layout>
                    {storage.getItem('userRole') === 'clientadmin' || storage.getItem('userRole') === 'areaManager' ? <Checklist_A /> : storage.getItem('userRole') === 'venueadmin' ? <CHecklist_V /> : <Navigate to='/maindashboard/dashboard' />}
                  </Layout>
                </PrivateRoute>
              }
            /> */}
            <Route
              path="/maindashboard/Checklist"
              element={
                <PrivateRoute>
                  <Layout>
                    {storage.getItem('userRole') === 'clientadmin' || storage.getItem('userRole') === 'areaManager' ? <ClientChecklistDashboard /> : storage.getItem('userRole') === 'venueadmin' ? <VenueChecklistDashboard /> : <Navigate to='/maindashboard/dashboard' />}
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route path="/maindashboard/Checklist/checklist-list" element={
              <PrivateRoute>
                <Layout>
                  <ChecklistList />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/maindashboard/Checklist/create-new-checklist" element={
              <PrivateRoute>
                <Layout>
                  <CreateChecklist />
                </Layout>
              </PrivateRoute>
            } />
            {/* <Route
              path="/maindashboard/newVenueChecklist"
              element={
                <PrivateRoute>
                  <Layout>
                    {storage.getItem('userRole') === 'clientadmin' || storage.getItem('userRole') === 'areaManager' ? <VenueChecklistDashboard /> : storage.getItem('userRole') === 'venueadmin' ? <VenueChecklistList /> : <Navigate to='/maindashboard/dashboard' />}
                  </Layout>
                </PrivateRoute>
              }
            /> */}

            <Route
              path="/maindashboard/CheckScoreCard"
              element={
                <PrivateRoute>
                  <Layout>
                    <CheckScoreCard />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/viewscorecard"
              element={
                <PrivateRoute>
                  <DownloadScorecard />
                </PrivateRoute>
              }
            />

            <Route
              path="/maindashboard/trendData"
              element={
                <PrivateRoute>
                  <Layout>
                    <TrendData />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/dataExplorer"
              element={
                <PrivateRoute>
                  <Layout>
                    <DataExplorer />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/manageSites"
              element={
                <PrivateRoute>
                  <Layout>
                    <ManageVenue />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/manageAreaManagers"
              element={
                <PrivateRoute>
                  <Layout>
                    <ManageArea />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/bscData"
              element={
                <PrivateRoute>
                  <Layout>
                    <Bsc />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/feedbackQuestions"
              element={
                <PrivateRoute>
                  <Layout>
                    <FeedbackQuestions />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/categoryreport"
              element={
                <PrivateRoute>
                  <Layout>
                    <CategoryComparisionReport />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/comparisionReports"
              element={
                <PrivateRoute>
                  <Layout>
                    <ComparisionReport />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route path="/maindashboard/comparisionReports/:comparisionType" element={<PrivateRoute>
              <Layout>
                <ComparisionReport />
              </Layout>
            </PrivateRoute>} />
            <Route
              path="/maindashboard/starRating/:starratingType"
              element={<PrivateRoute>
                <Layout>
                  <StarRating />
                </Layout>
              </PrivateRoute>} />
            <Route
              path="/maindashboard/starRating"
              element={
                <PrivateRoute>
                  <Layout>
                    <Navigate to='/maindashboard/starRating/monthlyreport' />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/starRating"
              element={
                <PrivateRoute>
                  <Layout>
                    <Navigate to='/maindashboard/starRating/monthlycomparisons' />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/sitedashboard"
              element={
                <PrivateRoute>
                  {/* <Layout> */}
                  <VenueDashboard />
                  {/* </Layout> */}
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/insightbot"
              element={
                <PrivateRoute>
                  <Layout>
                    <InsightBot />
                  </Layout>
                </PrivateRoute>
              }
            />

            <Route
              path="/maindashboard/new-checklist/businesschecklistquestions/:templateName/:BusinesschecklistId"
              element={
                <PrivateRoute>
                  <Layout>
                    <CreateBusinessChecklistQuestions />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/new-checklist/change-checklist-template-question-order/:templateName/:templateId"
              element={
                <PrivateRoute>
                  <Layout>
                    <ChangeChecklistQuestionOrder />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/new-checklist/create-new-question/:templateId"
              element={
                <PrivateRoute>
                  <Layout>
                    <CreateNewChecklistQuestion />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/checklist/checklist-list/checklist-questions/:businessCheckListSubmissionId"
              element={
                <PrivateRoute>
                  <Layout>
                    <VenueCheklistForm />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/maindashboard/checklist/checklist-submitted-list"
              element={
                <PrivateRoute>
                  <Layout>
                    <SubmittedChecklistList />
                  </Layout>
                </PrivateRoute>
              }
            />

            {/* <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/venue-map" element={<VenueMap />} /> */}
          </Routes>
        </Provider>
      </Box>
    </Box>
  )
}
export default AppRoutes
